import useStore from '../stores/store';

const getCustomEmojis = () => {
    let userData = useStore.getState().userData;

    let emojis = [];
    if (userData?.uploadedEmojis?.length > 0) {
        userData.uploadedEmojis.forEach((emoji) => {
            emojis.push({
                name: emoji.name,
                id: emoji.name.toLowerCase(),
                keywords: [emoji.name, 'Uploaded', 'Custom'],
                skins: [{ src: emoji.url }]
            });
        });
    }
    let customEmojiList = [
        {
            id: 'uploaded',
            name: 'Uploaded Emojis',
            emojis: emojis
        }
    ];

    return customEmojiList;
};

export default getCustomEmojis;

export const getCustomEmojiList = () => {
    const customEmojis = getCustomEmojis();
    return customEmojis[0]?.emojis?.map(emoji => ({
        name: emoji.name,
        url: emoji.skins[0].src
    })) || [];
};